import { render, staticRenderFns } from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=template&id=e37ac3c4&scoped=true"
import script from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37ac3c4",
  null
  
)

export default component.exports